// src/redux/slices/tenantConfigSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { safeParse } from "../../helper/helper";

const initialState = {
  config: null,
  hosttoken: null,
  // Bootstrap state of the tenant lookup, so the UI can tell apart
  // "tenant does not exist" from "could not reach the server".
  // idle | loading | ready | notFound | error
  status: "idle",
};

const tenantConfigSlice = createSlice({
  name: "tenantConfig",
  initialState,
  reducers: {
    setTenantConfig: (state, action) => {
      const { config, hosttoken, status } = action.payload;
      state.config = config || state.config;
      state.hosttoken = hosttoken || state.hosttoken;
      if (status) state.status = status;

      if (config) safeParse(sessionStorage.setItem("tenantConfig", JSON.stringify(config)));
      if (hosttoken) safeParse(sessionStorage.setItem("hosttoken", hosttoken));
    },
    setTenantStatus: (state, action) => {
      state.status = action.payload;
    },
    clearTenantConfig: (state) => {
      state.config = null;
      state.hosttoken = null;
      state.status = "idle";
      safeParse(sessionStorage.removeItem("tenantConfig"));
      safeParse(sessionStorage.removeItem("hosttoken"));
    },
  },
});

export const { setTenantConfig, setTenantStatus, clearTenantConfig } = tenantConfigSlice.actions;
export default tenantConfigSlice.reducer;
